import { render, staticRenderFns } from "./CategoryChip.vue?vue&type=template&id=047aff0e&scoped=true&"
import script from "./CategoryChip.vue?vue&type=script&lang=js&"
export * from "./CategoryChip.vue?vue&type=script&lang=js&"
import style0 from "./CategoryChip.vue?vue&type=style&index=0&id=047aff0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047aff0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
